import type { FC, ReactNode } from "react";

import { headerProvider } from "./HeaderProvider";

export type HeaderTranslations = {
  buttons: {
    create: string;
    login: string;
  };
};

export const HeaderTranslationProvider: FC<{
  value: HeaderTranslations;
  children: ReactNode;
}> = (props) => {
  return (
    <headerProvider.Provider value={props.value}>
      {props.children}
    </headerProvider.Provider>
  );
};
